module.exports = __webpack_public_path__ + "static/media/close_icon.f4c3d358.svg";